export const NGINX_UPLOAD_LIMIT = 5000000;
export const ONE_MEGABYTES = 1000000;
export const SECOND_IN_MS = 1000;



// WEBPACK FOOTER //
// ./src/config/magic-values.js